import {ReactElement} from "react";
import {FormattedMessage} from "react-intl";
import {SubTitle} from "components/UIComponents/SubTitle";
import {Tab} from "@headlessui/react";
import {WinePriceEditor} from "./WinePriceEditor";
import {EditorItem} from "../../editorUtils";
import {WineItem} from "../../MenuDocumentModel";
import {WineAppWineEditor} from "./WineAppWineEditor";
import {ExternalWineEditor} from "./ExternalWineEditor";

export interface WineEditorProps {
    wine: EditorItem<WineItem>
}

export function WineEditor(props: WineEditorProps): ReactElement {
    return (
        <div className="flex flex-col gap-4">
            <div className="px-6"><SubTitle>{props.wine.menuItem.name}</SubTitle></div>

            <Tab.Group>
                <Tab.List className="px-6 flex gap-10">
                    <Tab as="div">
                        {({selected}) => (
                            <button
                                className={`font-medium
                                            ${selected ? 'text-text border-b-2 border-b-text' : 'text-gray-1'}`}>
                                <FormattedMessage id="editor.wine.preferences"/>
                            </button>
                        )}
                    </Tab>
                    <Tab as="div">
                        {({selected}) => (
                            <button
                                className={`font-medium
                                            ${selected ? 'text-text border-b-2 border-b-text' : 'text-gray-1'}`}>
                                <FormattedMessage id="editor.wine.price"/>
                            </button>
                        )}
                    </Tab>
                </Tab.List>

                <Tab.Panels>
                    <Tab.Panel>
                        {props.wine.menuItem.external ? (
                            <ExternalWineEditor wine={props.wine} />
                        ) : (
                            <WineAppWineEditor wine={props.wine} />
                        )}
                    </Tab.Panel>

                    <Tab.Panel>
                        <WinePriceEditor wine={props.wine} />
                    </Tab.Panel>
                </Tab.Panels>
            </Tab.Group>
        </div>
    );
}

